import React from "react";
import { useState, useEffect } from "react";
import CloseIcon from '@mui/icons-material/Close';
import "./notification.css"

const Notification = () => {

    const [notificationOpen, closeNotification] = useState(true);

    useEffect(() => {
        const data = window.sessionStorage.getItem("notificationOpen");
        if (data !== null) closeNotification(JSON.parse(data))
    }, [])
    useEffect(() => {
        window.sessionStorage.setItem("notificationOpen", JSON.stringify(notificationOpen))
    }, [notificationOpen])

    return (
        <>
            {notificationOpen ?
                <div className="notification">
                    <button className="notificationButton" onClick={() => closeNotification((prev) => !prev)}>
                        <CloseIcon className="notificationIcon" />
                    </button>
                    <p>

                        <b>Liebe Patientinnen und Patienten,</b> <br></br><br></br>

                        unsere Praxis ist vom 12.10. bis einschließlich 16.10.2026 wegen Urlaub geschlossen.<br></br>
                        
                        In dringenden oder medizinischen Notfällen übernimmt unsere Vertretungspraxis Dr. Juliane Mehnert (Tel.: <a href="tel:+495351 6051">05351 6051</a> ) in Helmstedt die Versorgung. <br></br><br></br>

                        <b>Ab Montag, den 19.10.2026, sind wir wieder telefonisch für Sie erreichbar.<br></br><br></br></b>

                        Vielen Dank für Ihr Verständnis!<br></br>

                        <b>Ihr Praxisteam</b>
                    </p>
                </div>
                :
                ''
            }
        </>
    )
}

export default Notification